import { render, staticRenderFns } from "./MetricsRV.vue?vue&type=template&id=1c3cab10&scoped=true&"
import script from "./MetricsRV.vue?vue&type=script&lang=js&"
export * from "./MetricsRV.vue?vue&type=script&lang=js&"
import style0 from "./MetricsRV.vue?vue&type=style&index=0&id=1c3cab10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3cab10",
  null
  
)

export default component.exports